import{createContext as o}from"react";const r=o(null);export{r as defineStoreContext};//# sourceMappingURL=context.js.map
